import type { Locale } from "@/lib/i18n";
import { pl, type WShopRecomendedProductsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopRecomendedProductsTranslations: Record<
  Locale,
  WShopRecomendedProductsTranslations
> = {
  pl,
  en,
  de,
};

export type { WShopRecomendedProductsTranslations };
